import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';
import { useInView } from '../../hooks/useInView';

export const FinalCTASection = () => {
  const [ref, isInView] = useInView();

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-24 lg:py-32 bg-stone-950 overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(245,158,11,0.06),transparent_60%)]" />

      <div
        ref={ref}
        className={`relative max-w-3xl mx-auto px-6 lg:px-8 text-center transition-[opacity,transform] duration-700 ease-out ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-stone-100 mb-6 leading-tight">
          Ready to Ship Better
          <br />
          <span className="text-amber-400">Python Code?</span>
        </h2>
        <p className="text-lg text-stone-400 max-w-xl mx-auto mb-10 leading-relaxed">
          Get expert feedback that transforms your codebase. Choose a plan or
          tell us about your custom needs.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            className="bg-amber-500 hover:bg-amber-600 text-white px-8 h-12 text-base font-semibold shadow-lg shadow-amber-500/25 hover:shadow-amber-500/35 transition-[background-color,box-shadow] duration-300"
            onClick={() => scrollToSection('#pricing')}
          >
            Pick a Plan
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
          <Link to="/custom-quote">
            <Button
              variant="outline"
              size="lg"
              className="border-stone-700 text-stone-300 hover:bg-stone-900 hover:text-stone-100 px-8 h-12 text-base font-medium transition-[background-color,border-color,color] duration-200"
            >
              <MessageSquare className="mr-2 w-4 h-4" />
              Custom Needs
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
